export default "__VITE_ASSET__BUl9Ro_V__"